const getDuration = (timeInSec: number): string => {
	if (timeInSec <= 60) {
		return `${timeInSec.toFixed(0)} seconds`;
	}
	let minutes = Math.floor(timeInSec / 60);
	if (minutes < 60) {
		return `${minutes} minutes`;
	}
	const hours = Math.floor(minutes / 60);
	minutes %= 60;
	if (hours < 24) {
		return `${hours} hours ${minutes} minutes`;
	}
	const days = Math.floor(hours / 24);
	return `${days} ${days > 1 ? 'days' : 'day'}`;
};

export default getDuration;
